module.exports = __webpack_public_path__ + "img/p2.d26e218b.png";